import { Injectable } from '@angular/core';
import {
    ITask2ReportContainer,
    ITask2ReportData,
    ITask2ReportParameter,
    ITask2ReportSummary,
    ITask2ReportWidget,
    TTask2ReportSummaries,
} from '../fi-task-v2-report';
import { FiBackendService } from '@fi-shared/fi-backend/fi-backend.service';
import { LoadingService } from '@fi-shared/fi-loading/loading.service';

@Injectable()
export class FiTaskV2ReportService {
    constructor(
        private fiBackend: FiBackendService,
        private fiLoading: LoadingService,
    ) {}

    getReportContainer(): Promise<ITask2ReportContainer> {
        const promise = this.fiBackend.fetchData<ITask2ReportContainer>('Task/Task2Report/GetReportContainer');
        return this.fiLoading.trackPromise(promise);
    }

    getReportData(parameter: ITask2ReportParameter) {
        const promise = this.fiBackend.fetchDataPost<ITask2ReportData>('Task/Task2Report/GetReportData', parameter);
        return promise;
    }

    getReportSummary(parameter: ITask2ReportParameter) {
        const promise = this.fiBackend.fetchDataPost<ITask2ReportSummary>(
            'Task/Task2Report/GetReportSummary',
            parameter,
        );
        return promise;
    }

    getReportSummaries(widgets: ITask2ReportWidget[]): Promise<TTask2ReportSummaries> {
        const promise = this.fiBackend.fetchDataPost<TTask2ReportSummaries>(
            'Task/Task2Report/GetReportSummaries',
            widgets,
        );
        return promise;
    }

    saveReportWidget(widget: ITask2ReportWidget) {
        const promise = this.fiBackend.fetchDataPost<number>('Task/Task2Report/SaveReportWidget', widget);
        return this.fiLoading.trackPromise(promise);
    }

    getReportCount(): Promise<number> {
        // todo: we need to know what sort index is the last one
        return Promise.resolve(10);
    }

    deleteReportWidget(widgetId: number): Promise<void> {
        const promise = this.fiBackend.fetchDataPost<void>(`Task/Task2Report/DeleteReportWidget/${widgetId}`);
        return this.fiLoading.trackPromise(promise);
    }
}
